import Immutable from 'seamless-immutable';
import MobileDetect from 'mobile-detect';

import * as DeviceService from '../services/DeviceService';

import { stringArrayToObject } from './utils';

/* ------------- Device actions ------------- */
export const actions = stringArrayToObject(['SUBMIT_ADVICE'], '@@DEVICE');

const deviceDetector = new MobileDetect(window.navigator.userAgent);

export const actionCreators = {
  submitAdvice() {
    return async dispatch => {
      DeviceService.saveAdviceSubmitted();
      dispatch({
        type: actions.SUBMIT_ADVICE,
        payload: true
      });
    };
  }
};

const defaultState = {
  isMobile: !!deviceDetector.phone(),
  adviceSubmitted: DeviceService.adviceSubmitted()
};

/* ------------- Device reducer ------------- */
export function reducer(state = Immutable(defaultState), action) {
  switch (action.type) {
    case actions.SUBMIT_ADVICE: {
      return state.merge({ adviceSubmitted: action.payload });
    }
    default: {
      return state;
    }
  }
}
